export default {
  // Moment integration
  "Timestamp Date": "{{date, date}}",
  "Change Language": "Change Language",
  "Enter an Address, Transaction Hash or Block Number":
    "🔎 Enter an Address, Transaction Hash or Block Number",
  Github: "Github",
  "Block Height": "Block Height",
  "Chain ID": "Chain ID",
  Syncing: "Syncing",
  "Gas Price": "Gas Price",
  "Network Hash Rate": "Network Hash Rate",
  Peers: "Peers",
  "Hash Rate": "Hash Rate",
  "Transaction Count": "Transaction Count",
  "Gas Usage": "Gas Usage",
  "Top Collators": "Top Collators",
  "Top Collators by extraData": "Top Collators by extraData",
  "Top Collators by Address": "Top Collators by Address",
  "Block Number": "Block Number",
  Hash: "Hash",
  Timestamp: "Timestamp",
  Transactions: "Transactions",
  Number: "Number",
  ParentHash: "ParentHash",
  Nonce: "Nonce",
  "Extra Data": "Extra Data",
  "State Root": "State Root",
  "Transaction Root": "Transaction Root",
  "Receipts Root": "Receipts Root",
  Block: "Block",
  "Gas Used": "Gas Used",
  "Cumulative Gas Used": "Cumulative Gas Used",
  "Value in Ether": "Value in Ether",
  From: "From",
  To: "To",
  "Contract Address": "Contract Address",
  "Transaction Index": "Transaction Index",
  "Receipt Status": "Receipt Status",
  "Receipt Logs": "Receipt Logs",
  "No transactions for this block range":
    "No transactions for this block range",
  Address: "Address",
  Balance: "Balance",
  Code: "Code",
  Configuration: "Configuration",
  Back: "Back",
  "Ethereum RPC": "Ethereum RPC",
  "Service Runner RPC": "Service Runner RPC",
  AddChainDialog:
    "To add a chain to the chain list and begin using Tanssi Dancebox EVM ContainerChain Explorer with your own rpc provider, please enter the required fields below:",
};
